import styled from 'styled-components';
import { palette } from 'styled-tools';

import { fontSize, FontSizes, fontWeight, FontWeights, units } from '@calm-web/design-system';

export const ShortcutList = styled.dl`
	color: ${palette('gray8')};
	display: grid;
	grid-column-gap: ${units(3)};
	grid-row-gap: ${units(1.5)};
	grid-template-columns: max-content 1fr;
	margin: 0;
`;

export const Keys = styled.dt`
	${fontWeight(FontWeights.Medium)};
`;

export const Action = styled.dd`
	margin: 0;
`;

export const Key = styled.kbd`
	${fontSize(FontSizes.sm)};
	border: 1px solid ${palette('gray3')};
	border-radius: ${units(0.5)};
	font-family: inherit;
	padding: ${units(0.25, 0.75)};
`;
